// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1o2eU","content":"LoadingAlert_content__3ZzJA"};